import React from 'react';
import { useParams } from 'react-router-dom';
import { withFullScreenLoader } from '~/hocs/withFullScreenLoader';
import classes from './UploadRentRollPM.module.css';
import UploadRentRollCsvPM from './UploadRentRollCsvPM';

const UploadRentRollPM = () => {
  const { buildingId } = useParams<{ buildingId: string }>();

  return (
    <div className={classes.pageWrapper}>
      <div className={`flex-row align-start justify-between ${classes.headerWrapper}`}>
        <div>
          <div className={`margin-bottom-16 ${classes.title}`}>
            Upload Rent Roll to Cobu
          </div>
          <p>
            Upload your building's rent roll CSV file. The file will be sent to Cobu for
            processing.
          </p>
        </div>
      </div>
      <div className={classes.contentRow}>
        <div className={classes.requirementsBox}>
          <div className={classes.requirementsTitle}>File Upload Requirements</div>
          <p className={classes.requirementsSubtitle}>
            Please upload your resident file in <strong>CSV or Excel</strong> format (.csv, .xls, .xlsx, .xlsm, .xlsb). Files in any other format, such as PDF, will not be processed.
          </p>
          <p className={classes.requirementsSubtitle}>
            The file must include the following columns:
          </p>
          <ul className={classes.requirementsList}>
            <li>Name</li>
            <li>Email</li>
            <li>Phone</li>
            <li>Unit Number</li>
          </ul>
          <p className={classes.requirementsSubtitle}>
            These are recommended, but are not required, to include
          </p>
          <ul className={classes.requirementsList}>
            <li>Move-In Date</li>
            <li>Lease End Date</li>
          </ul>
          <p className={classes.requirementsSubtitle}>
            <strong>Important guidelines:</strong>
          </p>
          <ul className={classes.requirementsList}>
            <li>Only CSV or Excel files will be accepted</li>
            <li>File MUST contain residents and roommates otherwise roommates will be deactivated. If the file contains only the primary leaseholder information, DO NOT UPLOAD. Please contact us for recommended next steps.</li>
            <li>File MUST contain phone numbers and email addresses for matching purposes.</li>
            <li>Column headers must be clearly labeled</li>
            <li>Each resident and roommate needs to be in a separate row</li>
          </ul>
          <p className={classes.requirementsSubtitle}>
            This file helps us keep your resident roster up to date by deactivating former residents and inviting current residents to join Cobu.
          </p>
          <p className={classes.requirementsSubtitle}>
            By uploading this file, you acknowledge that the individuals included are current residents of the property and that the information may be used to update resident records and invite current residents to access the Cobu platform.
          </p>
        </div>
        <UploadRentRollCsvPM buildingId={buildingId} />
      </div>
    </div>
  );
};

export default withFullScreenLoader(UploadRentRollPM);
